export default "__VITE_ASSET__CuZAdWXB__"